import { SubDomain } from "../SubDomain.js";
import Equipment from "./Equipment";

export default class EquipmentDomain extends SubDomain {

  constructor(domain, storage) {
    super(domain, "Equipment");
    this.storage = storage;
  }

  list() {
    return this.storage.list;
  }

  findById(objId) {
    var objects = this.list();
    for (var i = 0; i < objects.length; i++) {
      var item = objects[i];
      if (super.toId(item) == objId) {
        return new Equipment(this.domain, item);
      }
    }

    return new Equipment(this.domain);
  }
}